import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import Button from '@adsk/bim360-matrix-react-button';

const EntityBlockLoadMore = ({ onLoadMore }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return (
    <Button
      styleType={Button.StyleType.INLINE_LINK}
      className="EntityBlockLoadMore"
      onClick={onLoadMore}
    >
      {T.translate('LOAD_MORE')}
    </Button>
  );
};

EntityBlockLoadMore.propTypes = {
  /**
   * Handler for load more click
   */
  onLoadMore: PropTypes.func
};

export default EntityBlockLoadMore;
